module.exports = __webpack_public_path__ + "img/slideshow.6fd23f30.png";